<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">

        <div class="card">
          <div class="pb-0 card-header">
            <div>
              <h5 class="mb-0">Configuração</h5>
              <p class="mb-0 text-sm">Configurações da Plataforma</p>

              <br>
              <ul class="nav nav-tabs">
                <li class="nav-item" v-for="g in grupos" :key="g">
                  <button
                    class="nav-link"
                    :class="{ active: activeGroup === g }"
                    @click="activeGroup = g"
                  >
                    {{ g }}
                  </button>
                </li>
              </ul>
            </div>
          </div>

          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th>Campo</th>
                    <th>Valor</th>
                    <th class="text-center">Ações</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="item in cfgFiltrada" :key="item.id">
                    <td>{{ item.nome_visivel }}</td>
                    <td>{{ parseValor(item) }}</td>
                    <td class="text-center">
                      <button class="btn btn-sm btn-primary" @click="openEditor(item)">
                        Editar
                      </button>
                    </td>
                  </tr>
                </tbody>

              </table>
            </div>
          </div>
        </div>

        <!-- Modal Editar -->
        <div class="modal fade" id="editModal" tabindex="-1">
          <div class="modal-dialog mt-lg-10">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Editar Configuração</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
              </div>

              <div class="modal-body">

                <label class="text-sm">Campo</label>
                <input type="text" class="form-control" v-model="selectedCfg.nome_visivel" disabled />

                <label class="mt-3 text-sm">Valor</label>

                <!-- JSON DINÂMICO -->
                <div v-if="selectedCfg.type === 'json'">

                  <div v-for="field in jsonEditor" :key="field.key" class="mb-3">
                    <label class="text-sm fw-bold">{{ field.key }}</label>

                    <!-- boolean -->
                    <div v-if="field.type === 'boolean'" class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" v-model="field.value">
                      <label class="form-check-label">{{ field.value ? "Ativado" : "Desativado" }}</label>
                    </div>

                    <!-- number -->
                    <input v-else-if="field.type === 'number'"
                      type="number"
                      class="form-control"
                      v-model="field.value"
                    />

                    <!-- mensagem -->
                    <textarea
                      v-else-if="field.key.toLowerCase().includes('mensagem')"
                      rows="3"
                      class="form-control"
                      v-model="field.value"
                    ></textarea>

                    <!-- texto -->
                    <input v-else type="text" class="form-control" v-model="field.value" />
                  </div>

                  <!-- PLACEHOLDERS DETECTADOS -->
                  <div class="mt-2">
                    <strong>Placeholders:</strong>

                    <div v-if="placeholders.length === 0" class="text-muted">
                      Nenhum placeholder encontrado.
                    </div>

                    <ul v-else>
                      <li v-for="p in placeholders" :key="p">
                        <code>#{{ p }}#</code>
                        <span class="text-muted"> → exemplo: <strong>{{ placeholderSamples[p] || '(sem)' }}</strong></span>
                      </li>
                    </ul>
                  </div>

                  <!-- PREVIEW -->
                  <div class="mt-3 p-3 bg-light rounded border">
                    <h6 class="text-secondary">Pré-visualização:</h6>
                    <pre>{{ jsonPreview }}</pre>
                  </div>

                </div>

                <!-- OUTROS TIPOS -->
                <div v-else>
                  <input v-if="selectedCfg.type === 'number'" type="number" class="form-control" v-model="selectedCfg.value">
                  <input v-else-if="selectedCfg.type === 'password'" type="password" class="form-control" v-model="selectedCfg.value">
                  <textarea v-else class="form-control" rows="3" v-model="selectedCfg.value"></textarea>
                </div>

              </div>

              <div class="modal-footer">
                <button class="btn btn-secondary btn-sm" data-bs-dismiss="modal">Cancelar</button>
                <button class="btn btn-success btn-sm" @click="saveCfg">Salvar</button>
              </div>
            </div>
          </div>
        </div>
        <!-- fim modal -->

      </div>
    </div>
  </div>
</template>


<script>
import * as bootstrap from 'bootstrap';
import { defineComponent } from "vue";
import fintailapi from "../api";

export default defineComponent({
  name: "configuracao",

  data() {
    return {
      cfg: [],
      grupos: [],
      activeGroup: "",

      selectedCfg: {
        id: null,
        key: "",
        value: "",
        type: ""
      },

      jsonEditor: [],

      placeholderSamples: {
        numero_pedido: "5841",
        status: "Em separação",
        valor: "129,90",
        nome_cliente: "João da Silva",
        data_entrega: "12/01/2025"
      }
    };
  },

  mounted() {
    this.getCfg();
  },

  computed: {
    cfgFiltrada() {
      return this.cfg.filter(c => c.grupo === this.activeGroup);
    },

    placeholders() {
      return this.extractPlaceholders(JSON.stringify(this.getJsonObject()));
    },

    jsonPreview() {
      const obj = this.getJsonObject();
      return JSON.stringify(obj, null, 2);
    }
  },

  methods: {

    // pega JSON do editor dinamicamente
    getJsonObject() {
      const obj = {};
      this.jsonEditor.forEach(f => obj[f.key] = f.value);
      return obj;
    },

    extractPlaceholders(text) {
      if (!text) return [];
      const matches = text.match(/#(.*?)#/g);
      return matches ? matches.map(m => m.replace(/#/g, "")) : [];
    },

    parseValor(item) {
      switch (item.type) {
        case "bool": return item.value === "true" ? "Sim" : "Não";
        case "json":
          try { return JSON.stringify(JSON.parse(item.value), null, 2); }
          catch { return item.value; }
        case "password": return "******";
        default: return item.value;
      }
    },

    getCfg() {
      fintailapi.get(`/configuracao`)
        .then((response) => {
          this.cfg = response.data.rows;
          this.grupos = [...new Set(this.cfg.map(c => c.grupo))];
          if (!this.activeGroup) this.activeGroup = this.grupos[0];
        });
    },

    buildJsonEditor() {
      try {
        const obj = JSON.parse(this.selectedCfg.value);
        this.jsonEditor = Object.keys(obj).map(key => ({
          key,
          value: obj[key],
          type: typeof obj[key]
        }));
      } catch {
        this.jsonEditor = [];
      }
    },

    openEditor(item) {
      this.selectedCfg = { ...item };

      if (item.type === "json") {
        try {
          this.selectedCfg.value = JSON.stringify(JSON.parse(item.value), null, 2);
        } catch {}

        this.buildJsonEditor();
      } else {
        this.jsonEditor = [];
      }

      const modal = new bootstrap.Modal(document.getElementById("editModal"));
      modal.show();
    },

    saveCfg() {
      let valueToSave = this.selectedCfg.value;

      if (this.selectedCfg.type === "json") {
        valueToSave = JSON.stringify(this.getJsonObject());
      }

      fintailapi.put(`/configuracao/${this.selectedCfg.id}`, {
        value: valueToSave
      })
        .then(() => {
          this.getCfg();
          const modal = bootstrap.Modal.getInstance(document.getElementById("editModal"));
          modal.hide();
        })
        .catch(console.error);
    }

  }
});
</script>
